import { createRouter, createWebHistory } from "vue-router";
import AuthLayout from '@/views/auth/Layout.vue';
import AppLayout from '@/views/layouts/Layout.vue';
import Guest from '@/views/auth/Guest.vue';
import Login from '@/views/auth/Login.vue';
// import Register from '@/views/auth/Register.vue';
import Dashboard from '@/views/Dashboard.vue';

import UjilabPengajuan from '@/views/ujilab/Pengajuan.vue';
import UjilabPenerimaan from '@/views/ujilab/Penerimaan.vue';
import UjilabPenerimaanForm from '@/views/ujilab/PenerimaanForm.vue';
import UjilabPengujian from '@/views/ujilab/Pengujian.vue';
import UjilabPengujianPengujian from '@/views/ujilab/pengujian/Pengujian.vue';
import UjilabProsesPengujian from '@/views/ujilab/pengujian/ProsesPengujian.vue';
import UjilabPengujianInputUji from '@/views/ujilab/pengujian/HasilUji.vue';
import UjilabPengujianUploadAnalisis from '@/views/ujilab/pengujian/UploadAnalisis.vue';

import PenyewaanPengajuan from '@/views/penyewaan/Index.vue';
import PenyewaanPengajuanForm from '@/views/penyewaan/Pengajuan.vue';
import PenyewaanAlatBerat from '@/views/penyewaan/MasterAlatBerat.vue';
import PenyewaanAlatBeratForm from '@/views/penyewaan/MasterAlatBeratForm.vue';

import TrackingPengajuan from '@/views/tracking/Tracking.vue';


// import AdminMasterUser from '@/views/admin/master/user/Index.vue';
// import AdminMasterForm from '@/views/admin/master/user/Form.vue';
// import AdminMasterAlatSewa from '@/views/admin/master/alat_sewa/Index.vue';
// import GuestPengujian from '@/views/ujilab/guest/pengujian/Index.vue';
// import GuestPengujianForm from '@/views/ujilab/guest/pengujian/Form.vue';
// import OperatorPenerimaan from '@/views/ujilab/operator/penerimaan/Index.vue';
// import OperatorPenerimaanForm from '@/views/ujilab/operator/penerimaan/Form.vue';
// import OperatorPengujian from '@/views/ujilab/operator/pengujian/Index.vue';
// import OperatorPengujianForm from '@/views/ujilab/operator/pengujian/Form.vue';

const routes = [
  { path: '', redirect: '/guest' },
  {
    component: AuthLayout, children: [
      { path: '/guest', component: Guest, name: 'auth.guest' },
      { path: '/auth-login', component: Login, name: 'auth.login' },
      // { path: '/auth-register' , component: Register, name : 'auth.register' },
    ],
  },
  {
    component: AppLayout, children: [
      { path: '/dashboard', component: Dashboard, name: 'dashboard' },

      //Administrator
      // { path : '/admin-master-user', component: AdminMasterUser, name: 'master.user' },
      // { path : '/admin-master-create', component: AdminMasterForm, name: 'master.user.create' },
      // { path : '/admin-master-edit/:id', component: AdminMasterForm, name: 'master.user.edit' },


      // Uji Lab
      { path: '/ujilab-pengajuan', component: UjilabPengajuan, name: 'ujilab.pengajuan' },
      { path: '/ujilab-penerimaan', component: UjilabPenerimaan, name: 'ujilab.penerimaan' },
      { path: '/ujilab-penerimaan-terima/:id', component: UjilabPenerimaanForm, name: 'ujilab.penerimaan.form' },
      { path: '/ujilab-pengujian', component: UjilabPengujian, name: 'ujilab.pengujian' },
      { path: '/ujilab-pengujian-pengujian/:id', component: UjilabPengujianPengujian, name: 'ujilab.pengujian.form-pengujian' },
      { path: '/ujilab-pengujian-proses/:id', component: UjilabProsesPengujian, name: 'ujilab.pengujian.form-proses' },
      { path: '/ujilab-pengujian-input-uji/:id', component: UjilabPengujianInputUji, name: 'ujilab.pengujian.form-input-uji' },
      { path: '/ujilab-pengujian-upload-analisis/:id', component: UjilabPengujianUploadAnalisis, name: 'ujilab.pengujian.form-upload' },

      // { path : '/ujilab-pengujian-download/:id', redirect: 'http://localhost:8000/anjay', name: 'ujilab.pengujian.download'},


      { path: '/penyewaan-pengajuan', component: PenyewaanPengajuan, name: 'penyewaan.pengajuan' },
      { path: '/penyewaan-pengajuan/:id', component: PenyewaanPengajuanForm, name: 'penyewaan.pengajuan.update' },
      { path: '/penyewaan-pengajuan-create', component: PenyewaanPengajuanForm, name: 'penyewaan.pengajuan.create' },
      { path: '/penyewaan-master-alat-berat', component: PenyewaanAlatBerat, name: 'penyewaan.alat-berat' },
      { path: '/penyewaan-master-alat-berat-create', component: PenyewaanAlatBeratForm, name: 'penyewaan.alat-berat.create' },
      { path: '/penyewaan-master-alat-berat-edit/:id', component: PenyewaanAlatBeratForm, name: 'penyewaan.alat-berat.edit' },

      // { path : '/admin-master-alat-sewa', component: AdminMasterAlatSewa, name: 'master.alat-sewa' },

      // Operator
      // { path : '/operator-penerimaan', component: OperatorPenerimaan, name: 'operator.penerimaan' },
      // { path : '/operator-penerimaan-update/:id', component: OperatorPenerimaanForm, name: 'operator.penerimaan.update' },
      // { path : '/operator-pengujian', component: OperatorPengujian, name: 'operator.pengujian' },
      // { path : '/operator-pengujian-update/:id', component: OperatorPengujianForm, name: 'operator.pengujian.update' },

      // Guest
      // { path : '/guest-pengujian', component: GuestPengujian, name: 'guest.pengujian' },
      // { path : '/guest-pengujian-create', component: GuestPengujianForm, name: 'guest.pengujian.create' },
      // { path : '/guest-pengujian-edit/:id', component: GuestPengujianForm, name: 'guest.pengujian.edit' },

      // { path : '/guest-penyewaan', component: Dashboard, name: 'guest.penyewaan' },

      { path: '/tracking-pengajuan/:id', component: TrackingPengajuan, name: 'tracking.tracking' },
    ]
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), routes, linkActiveClass: "active",
});

export default router;
